module.exports = __webpack_public_path__ + "assets/MidpointDetailed.fc3f188c78a654ff325904a334156a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/MidpointDetailed.png
// module id = 538
// module chunks = 0